<script>
// import PageEditor from './PageEditor/PageEditor';

export default {
  props: ['item'],
  data() {
    return {
      selected_section: '',

      widgets: [
        { name: 'Custom content', value: 'grid'},
        { name: 'Page header', value: 'page-header'},
        { name: 'Page video header', value: 'page-video-header'},
        { name: 'Packages', value: 'packages'},
        { name: 'Services', value: 'services'},
        { name: 'Calculate savings', value: 'calculate-savings'},
        { name: 'Testimonials', value: 'testimonials'},
        { name: 'Featured testimonials', value: 'featured-testimonials'},
        { name: 'Valuation', value: 'valuation'},
        { name: 'Blog', value: 'blog'},
        { name: 'Preferred Partners', value: 'preferred-partners'},
        { name: 'FAQ', value: 'faq'},
        { name: 'Listing process', value: 'listing-process'},
        { name: 'Button boxes', value: 'button-boxes'},
        { name: 'Services quiz', value: 'services-quiz'},
        { name: 'My listings', value: 'my-listings'},
        { name: 'Listing form', value: 'listing-form'},
        { name: 'Listings map', value: 'listings-map'},
        { name: 'Offices', value: 'offices'},
        { name: 'Agent form', value: 'agent-form'},
        { name: 'Contact us form', value: 'contact-us'},
        { name: 'My Profile', value: 'my-profile'},
        { name: 'Login form', value: 'login-form'},
        { name: 'Register form', value: 'register-form'},
      ],

      loading_roles: true,
      roles: [],
    }
  },
  computed: {
    compRoles: function() {
      var results = [];
      for(var i in this.roles) {
        if(this.roles[i].title) { results.push({name: this.roles[i].title, value: this.roles[i].title}); }
      }
      return results;
    },
  },
  created() {
    this.fetch_roles();
  },
  methods: {
    fetch_roles() {
      this.loading_roles = true;
      this.$http.get('/api/roles/fetch').then(res => {
        // console.log(res);
        this.roles = res.data.data;
        this.loading_roles = false;
      }).catch(res => { this.loading_roles = false; this.popupErrors(res); });
    },
    add_section() {
      if(this.selected_section) {
        var result = {type: this.selected_section, init: 'Yes', pre_btn: [], post_btn: []};

        // Add reactivity for columns on grids
        // if(this.selected_section == 'grid') { result.columns = []; }

        // Add reactivity for buttons on testimonials
        // if(this.selected_section == 'testimonials') { result.buttons = []; }

        this.item.content.push(result);
      }
    },
    delete_content(content_i) {
      if(!this.item.content[content_i]) { this.$noty.warning('<i class="far fa-bell mr-1"></i> ID not found'); return; }
      var n = this.$noty.error('<div>Are you sure you want to delete this content? This action cannot be undone.</div>', { timeout: false, modal: true, type: 'default', layout: 'center', closeWith: ['button'],
        buttons: [
          Noty.button('YES', 'btn btn-block btn-light', res => {
            this.item.content.splice(content_i, 1);
            this.$noty.success("Content removed");
            n.close();
          }, {id: 'button1', 'data-status': 'ok'}),
        ]
      }).on('onClose', () => { });
    },
  }
}
</script>

<template>
  <div>

    <h5 class="section-header mb-3"><Icon icon="ri:book-2-line" /> Page settings :</h5>
    <div class="row">
      <div class="col-sm-4">
        <w-field SimpleDataType="String List, Single" v-model="item.status" :Options="[{name: 'Yes', value: '1'}, {name: 'No', value: '0'}]" Title="Live :" Required></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" v-model="item.title" Title="Title :" Required></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" v-model="item.slug" Title="Slug :" Required></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String List, Single" v-model="item.website" :Options="app_website_ids" Title="Website :" required></w-field>
      </div>
      <div class="col-sm-4">
        <w-field Title="Navbar : " SimpleDataType="String List, Single" v-model="item.navbar" :Options="[{name: 'Yes', value: '1'}, {name: 'No', value: '0'}]"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field Title="Static Navbar : " SimpleDataType="String List, Single" v-model="item.static_navbar" :Options="[{name: 'Yes', value: '1'}, {name: 'No', value: '0'}]"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field Title="Footer : " SimpleDataType="String List, Single" v-model="item.footer" :Options="[{name: 'Yes', value: '1'}, {name: 'No', value: '0'}]"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field Title="Require login : " SimpleDataType="String List, Single" v-model="item.auth" :Options="[{name: 'Yes', value: '1'}, {name: 'No', value: '0'}]"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field Title="Require role(s) :" SimpleDataType="String List, Multi" v-model="item.roles" :Options="compRoles"></w-field>
      </div>
    </div>
    <h5 class="section-header mt-5 mb-3"><Icon icon="ri:book-2-line"></Icon> META details :</h5>
    <div class="row">
      <div class="col-sm-4">
        <w-field class="mb-0" SimpleDataType="String" v-model="item.meta_title" Title="META title :" ></w-field>
        <small v-if="item.meta_title" :class="item.meta_title.length > 60 ? 'text-danger' : 'text-muted'">60 or less recommended ({{item.meta_title.length}}/60)</small>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" v-model="item.meta_image" Title="META image :" ></w-field>
      </div>
      <div class="col-sm-4">
        <w-field class="mb-0" SimpleDataType="Textarea" v-model="item.meta_description" Title="META description :" ></w-field>
        <small v-if="item.meta_description" :class="item.meta_description.length > 160 ? 'text-danger' : 'text-muted'">160 or less recommended ({{item.meta_description.length}}/160)</small>
      </div>
    </div>
    <h5 class="section-header mt-5 mb-3"><Icon icon="ri:book-2-line"></Icon> Code snippets :</h5>
    <div class="form-group">
      <label>Header snippets :</label>
      <component is="PrismEditorMain" v-model="item.page_header_snippets"></component>
    </div>
    <div class="form-group">
      <label>Footer snippets :</label>
      <component is="PrismEditorMain" v-model="item.page_footer_snippets"></component>
    </div>
    <h5 class="section-header mt-5 mb-3"><Icon icon="ri:book-2-line"></Icon> Page content :</h5>
    <draggable handle=".handle" v-bind="{animation: 200}" :force-fallback="true" v-model="item.content">
      <transition-group tag="div">
        <div v-for="(content, content_i) in item.content" :key="'c'+content_i" class="mt-4">

          <div class="border border-info _b-s-3">
            <div class="bg-info p-1">
              <div class="float-right">
                <button type="button" class="btn btn-sm btn-white ml-1" style="padding: 2.9px 10px;" v-tippy content="Click to delete" @click="delete_content(content_i)"><Icon icon="ri:delete-bin-7-line"></Icon></button>
                <button type="button" class="btn btn-sm btn-white handle ml-1" style="padding: 2.9px 10px;" v-tippy content="Drag to rearrange"><Icon icon="ri:drag-move-2-line"></Icon></button>
              </div>
              <h5 class="m-2">{{content.title}}</h5>
              <div class="clearfix"></div>
            </div>
            <div class="">
              <component v-if="widgets.map(a => a.value).includes(content.type)" :is="'w-'+content.type" type="editor" :pc="content" :website="[]"></component>
            </div>
          </div>
        </div>
      </transition-group>
    </draggable>

    <b-form @submit.prevent="add_section()">
      <div class="row mt-5">
        <div class="col-sm-6">
          <w-field SimpleDataType="String List, Single" v-model="selected_section" Title="Add section :" :Options="widgets"></w-field>
          <button type="submit" class="btn btn-block btn-primary" v-tippy content="Add content"><Icon icon="ri:add-line" height="18"></Icon> Add section</button>
        </div>
      </div>
    </b-form>

  </div>
</template>
